import styled from 'styled-components';
import { getScrollBarStyles } from '../../../../../config/styles';
import { theme } from '../../../../../styles/theme';

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-bottom: 8px;
`;

export const BucketsContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
  margin-right: -10px;
  ${getScrollBarStyles(4)}
`;

export const Bracket = styled.div`
  display: grid;
  grid-template-columns: 16px 1fr 24px;
  column-gap: 8px;
  width: 100%;
`;

export const BracketContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  row-gap: 4px;
  width: 100%;
  max-width: 240px;
`;

export const CustomName = styled.div`
  max-width: 184px;
  margin-left: 24px;
  font-weight: 600;
  color: ${theme.colors.secondary800};
  word-break: break-all;
`;

export const Text = styled.div`
  padding-top: 2px;
  font-weight: 500;
  color: ${theme.colors.secondary800};
`;
